// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'

var EntitlementProductDefinitionGroup = function (pfixFieldSet)
{
    PFixFieldSet.call(this, FieldsFactory.PRODUCT_DEFINITION_GROUP, null, pfixFieldSet)
}

EntitlementProductDefinitionGroup.prototype = Object.create(PFixFieldSet.prototype)


EntitlementProductDefinitionGroup.prototype.GetProductDefinition = function ()
{
    let result = {};
    result.BasisType = this.GetValue(FieldsFactory.FIELD_PRODUCT_BASIS_TYPE);
    result.InstrumentIds = this.GetValue(FieldsFactory.FIELD_INSTRUMENT_IDS);
    result.InstrumentGroups = this.GetValue(FieldsFactory.FIELD_INSTRUMENT_GROUP_IDS);
    result.TradingExchanges = this.GetValue(FieldsFactory.FIELD_TRADING_EXCHANGES);
    result.IsDataSource = this.GetValue(FieldsFactory.FIELD_IS_DATA_SOURCE);

    return result
}

export { EntitlementProductDefinitionGroup }